import { render, staticRenderFns } from "./FundAllocator.vue?vue&type=template&id=87f742b2&"
import script from "./FundAllocator.vue?vue&type=script&lang=js&"
export * from "./FundAllocator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports